import React from "react";

function Footer() {
  return (
    <>
      {/*  Footer Start  **/}
      <div className="section footer-section">
        {/*  Footer Widget Section Start **/}
        <div className="footer-widget-section">
          <img
            className="shape-1 animation-down"
            src="assets/images/shape/shape-21.png"
            alt="Shape"
          />

          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 order-md-1 order-lg-1">
                {/*  Footer Widget Start **/}
                <div className="footer-widget">
                  <div className="widget-logo">
                    <a href="/#">
                      <img src="assets/images/logo.png" alt="Logo" />
                    </a>
                  </div>

                  <div className="widget-address">
                    <h4 className="footer-widget-title">Techi Jack</h4>
                    <p>Exchange Server &amp; IT Training Courses</p>
                  </div>

                  <ul className="widget-info">
                    <li>
                      <p>
                        {" "}
                        <i className="flaticon-email"></i>{" "}
                        <a href="mailto:info@techijack.com">
                          info@techijack.com
                        </a>{" "}
                      </p>
                    </li>
                  </ul>

                  <ul className="widget-social">
                    <li>
                      <a
                        href="https://www.facebook.com/ServerTraining"
                        target={"_blank"}
                        rel="noopener noreferrer"
                      >
                        <i className="flaticon-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://twitter.com/jack_techi"
                        target={"_blank"}
                        rel="noopener noreferrer"
                      >
                        <i className="flaticon-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="skype:vicky00284?chat"
                        target={"_blank"}
                        rel="noopener noreferrer"
                      >
                        <i className="flaticon-skype"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/c/techijack?sub_confirmation=1"
                        target={"_blank"}
                        rel="noopener noreferrer"
                      >
                        <i className="flaticon-tutor"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                {/*  Footer Widget End **/}
              </div>
              <div className="col-lg-6 order-md-3 order-lg-2">
                {/*  Footer Widget Link Start **/}
                <div className="footer-widget-link">
                  {/*  Footer Widget Start **/}
                  <div className="footer-widget">
                    <h4 className="footer-widget-title">Blog Category</h4>

                    <ul className="widget-link">
                      <li>
                        <a href="https://techijack.com/category/microsoft/exchange-server-2019/">
                          Exchange Server 2019
                        </a>
                      </li>
                      <li>
                        <a href="https://techijack.com/category/microsoft/exchange-server-2016/">
                          Exchange Server 2016
                        </a>
                      </li>
                      <li>
                        <a href="https://techijack.com/category/microsoft/windows-server-2019/">
                          Windows Server 2019
                        </a>
                      </li>
                      <li>
                        <a href="https://techijack.com/category/microsoft/windows-server-2016/">
                          Windows Server 2016
                        </a>
                      </li>
                      <li>
                        <a href="https://techijack.com/category/cloud/microsoft-365/">
                          Microsoft 365
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/*  Footer Widget End **/}

                  {/*  Footer Widget Start **/}
                  <div className="footer-widget">
                    <h4 className="footer-widget-title">Quick Links</h4>

                    <ul className="widget-link">
                      <li>
                        <a
                          href="https://techijack.com/privacy-policy/"
                          target={"_blank"}
                          rel="noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://techijack.com/terms/"
                          target={"_blank"}
                          rel="noreferrer"
                        >
                          Terms & Conditions
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/*  Footer Widget End **/}
                </div>
                {/*  Footer Widget Link End **/}
              </div>
              <div className="col-lg-3 col-md-6 order-md-2 order-lg-3">
                {/*  Footer Widget Start **/}
                <div className="footer-widget">
                  <h4 className="footer-widget-title">Subscribe Youtube Channel</h4>
                  <div className="widget-subscribe">
                    <a href="https://www.youtube.com/c/techijack?sub_confirmation=1">
                      <img src="assets/images/subscribe_buttonyt.png" alt="Subscribe Techijack"/>
                    </a>
                  </div>
                </div>
                {/*  Footer Widget End **/}
              </div>
            </div>
          </div>
          <img
            className="shape-2 animation-left"
            src="assets/images/shape/shape-22.png"
            alt="Shape"
          />
        </div>
        {/*  Footer Widget Section End **/}

        {/*  Footer Copyright Start **/}
        <div className="footer-copyright">
          <div className="container">
            <p className="gsp-disc">
              All third party trademarks™ or registered® trademarks including
              logos and icons referenced by Techi Jack remain the property of
              their respective owners. Exchange Server, Windows, Windows Server,
              and DirectSound are registered trademarks of Microsoft
              Corporation. Unless specifically identified as such, Techijack use
              of third party trademarks does not indicate any relationship,
              sponsorship, or endorsement between Techijack and the owners of
              these trademarks. Any references by Techijack to third party
              trademarks is to identify the corresponding third party goods
              and/or services and shall be considered nominative fair use under
              the trademark law.
            </p>
            {/*  Footer Copyright Start **/}
            <div className="copyright-wrapper">
              <div className="copyright-link">
                <a
                  href="https://techijack.com/terms/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  Terms of Service
                </a>
                <a
                  href="https://techijack.com/privacy-policy/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </div>
              <div className="copyright-text">
                <p>
                  &copy; 2023 <span> Techi Jack </span> by{" "}
                  <a href="https://withgovind.com/">withGovind</a>
                </p>
              </div>
            </div>
            {/*  Footer Copyright End **/}
          </div>
        </div>
        {/*  Footer Copyright End **/}
      </div>
      {/*  Footer End **/}

      {/* Back To Start**/}
      <a href="/#" className="back-to-top">
        <i className="icofont-simple-up"></i>
      </a>
      {/* Back To End**/}
    </>
  );
}

export default Footer;
